import { Table } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../components/Reminder.css";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import { Modal, Slide, Box, Typography, Backdrop } from "@mui/material";
import useCountStore from "../components/store";
import Button from "@mui/material/Button";

export default function DataCycle({ user, refresh }) {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [id, setId] = useState();
  const count = useCountStore((state) => state.count);
  const setCount = useCountStore((state) => state.setCount);

  useEffect(() => {
    const fetchData = async () => {
      const url = `${API_URL}/getcycle/${userData.cookie}/${user}`;
      try {
        const response = await axios.get(url);
        setData(response.data);
      } catch (error) {
        console.error(
          "Błąd podczas pobierania danych. Najprawdopodobniej utracono połączenie z internetem.",
          error
        );
      }
    };

    if (userData && count) {
      fetchData();
      const intervalId = setInterval(fetchData, 1000);
      return () => clearInterval(intervalId);
    }
  }, [userData, count, user]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let all = `${year}-${month}-${day}`;
    if (all === "1970-01-01") {
      all = "bezterminowo";
    }
    return all;
  };

  const [open, setOpen] = useState(false);
  const handleOpen = (id) => {
    setOpen(true);
    setId(id);
  };

  const handleClose = () => setOpen(false);

  const handleDelete = async () => {
    try {
      const response = await axios.put(
        API_URL + `/deleteremindercycle/${userData.cookie}`,
        { id: id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.error === 200) {
        setCount(count + 1);
      }
    } catch (error) {
      console.error("Błąd podczas próby skasowania elementu", error);
    }
    setOpen(false);
  };

  if (userData && userData.grpAdmin === "1") {
    return (
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Slide direction="up" in={open} mountOnEnter unmountOnExit>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                borderRadius: 1,
                boxShadow: 24,
                p: 4,
              }}
            >
              <Typography variant="h6" component="h2" gutterBottom>
                Czy na pewno chcesz usunąć ten element?
              </Typography>

              <Box mt={2} display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  Usuń
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleClose}
                >
                  Zamknij
                </Button>
              </Box>
            </Box>
          </Slide>
        </Modal>

        <Table striped bordered hover className="table">
          <thead>
            <tr>
              <th>Dzień</th>
              <th>Zadanie</th>
              <th>Lb. powtórzeń/dzień</th>
              <th>Od</th>
              <th>Do</th>
              <th>Usuń</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const showDay = index === 0 || item.day !== data[index - 1].day;
              return (
                <tr key={item.id}>
                  <td data-label="Dzień">
                    {showDay ? <b>{item.day}</b> : null}{" "}
                  </td>
                  <td data-label="Zadanie">{item.activitie}</td>
                  <td data-label="Repeats">{item.cnt}</td>
                  <td data-label="Od">{formatDate(item.datefrom)}</td>
                  <td data-label="Do">{formatDate(item.dateto)}</td>
                  <td data-label="Skasuj">
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => handleOpen(item.id)}
                    >
                      <i className="fa fa-trash" aria-hidden="true"></i>
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}
